import { render, staticRenderFns } from "./UpcomingScheduleOld.vue?vue&type=template&id=96f4c0e4&scoped=true"
import script from "./UpcomingScheduleOld.vue?vue&type=script&lang=js"
export * from "./UpcomingScheduleOld.vue?vue&type=script&lang=js"
import style0 from "./UpcomingScheduleOld.vue?vue&type=style&index=0&id=96f4c0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f4c0e4",
  null
  
)

export default component.exports